import {rePostionContents, reSizeBackground} from "./cavasResize";
import {gsap} from "gsap";
import { PixiPlugin } from "gsap/PixiPlugin";

gsap.registerPlugin(PixiPlugin);
const loader = PIXI.Loader.shared;

promokit.preload({
    delay: 1,
    complete: function() {

        $(document).on('click', '.p-link__item--2', function(e) {
            e.preventDefault();
            location.href = 'https://bns.plaync.com/promo/bns/210127_soul';
        });
    }
});






let opts = {
    w: $(window).width(),
    h: $(window).height(),
}





let _path = promokit.store('staticPath');
loader.add('bg', _path + '/promo/bns/event/2021/210113_index/img/bg.jpg');
loader.add('charLeft', _path + '/promo/bns/event/2021/210113_index/img/char-left.png');
loader.add('charRight', _path + '/promo/bns/event/2021/210113_index/img/char-right.png');
loader.add('effect1', _path + '/promo/bns/event/2021/210113_index/img/link1-over.png');
loader.add('effect2', _path + '/promo/bns/event/2021/210113_index/img/link2-over.png');
loader.add('effect3', _path + '/promo/bns/event/2021/210113_index/img/link3-over.png');

const sprites = {};
loader.load((loader, resources) => {
    sprites.bg = new PIXI.Sprite.fromImage(resources.bg.texture);
    sprites.charLeft = new PIXI.Sprite.fromImage(resources.charLeft.texture);
    sprites.charRight = new PIXI.Sprite.fromImage(resources.charRight.texture);
    sprites.effect1 = new PIXI.Sprite.fromImage(resources.effect1.texture);
    sprites.effect2 = new PIXI.Sprite.fromImage(resources.effect2.texture);
    sprites.effect3 = new PIXI.Sprite.fromImage(resources.effect3.texture);
});

loader.onComplete.add(() => {
    // canvas init
    let mainCanvas = {};
    mainCanvas.app = new PIXI.Application({ width: opts.w, height: opts.h, backgroundAlpha: 1 });
    $('.p-sec1__bg').append(mainCanvas.app.view);

    mainCanvas.filters = {};
    mainCanvas.filters.zoomBlurFilter = new PIXI.filters.ZoomBlurFilter();
    mainCanvas.filters.zoomBlurFilter.center = [opts.w/2, opts.h/2];
    mainCanvas.filters.zoomBlurFilter.innerRadius = 0;


    mainCanvas.bg = sprites.bg;
    mainCanvas.bg.anchor.x = 0;
    mainCanvas.bg.position.x = (opts.w-2560)/2;
    mainCanvas.bg.filters = [mainCanvas.filters.zoomBlurFilter];
    mainCanvas.app.stage.addChild(mainCanvas.bg);

    mainCanvas.con = new PIXI.Container();
    mainCanvas.con.x = opts.w/2 - 1920/2;
    mainCanvas.con.y = 0;
    mainCanvas.app.stage.addChild(mainCanvas.con);

    mainCanvas.charLeft = sprites.charLeft;
    mainCanvas.charLeft.x = 377;
    mainCanvas.charLeft.y = 410;
    mainCanvas.con.addChild(mainCanvas.charLeft);

    mainCanvas.charRight = sprites.charRight;
    mainCanvas.charRight.x = 1247;
    mainCanvas.charRight.y = 370;
    mainCanvas.con.addChild(mainCanvas.charRight);

    mainCanvas.effect1 = sprites.effect1;
    mainCanvas.effect1.x = 590;
    mainCanvas.effect1.y = 349;
    mainCanvas.effect1.alpha = 0;
    mainCanvas.con.addChild(mainCanvas.effect1);

    mainCanvas.effect2 = sprites.effect2;
    mainCanvas.effect2.x = 1103;
    mainCanvas.effect2.y = 349;
    mainCanvas.effect2.alpha = 0;
    mainCanvas.con.addChild(mainCanvas.effect2);

    mainCanvas.effect3 = sprites.effect3;
    mainCanvas.effect3.x = 848;
    mainCanvas.effect3.y = 608;
    mainCanvas.effect3.alpha = 0;
    mainCanvas.con.addChild(mainCanvas.effect3);

    $(window).on('resize', function(){
        let opts = {
            w: $(window).width(),
            h: $(window).height(),
        }

        mainCanvas.bg.position.x = (opts.w-2560)/2;
        rePostionContents(mainCanvas.con, opts.w, opts.h, 1920, 1080, true);

        mainCanvas.app.renderer.resize(opts.w, opts.h);

        if( opts.w <= 1100 ){
            console.log('123123');
            mainCanvas.bg.position.x = (1100-2560)/2;
            rePostionContents(mainCanvas.con, 280, 0, 1100, 1080, true);
            mainCanvas.app.renderer.resize(1100, opts.h);
        }
    });

    // motions
    const animation = gsap.timeline({paused: true, delay: 0.5 })
        .addLabel('step1')
        .fromTo(mainCanvas.filters.zoomBlurFilter, { strength: 0.2 }, { strength: 0, duration: 1 }, 'step1')

        .from('.p-sec1__title', { duration: 1, y: 50, ease: 'power2.out', opacity: 0 }, 'step1+=0.8')
        .from('.p-sec1__sub-title', { duration: 1, y: 50, ease: 'power2.out', opacity: 0 }, 'step1+=1.0')
        .from('.p-sec1__title-text', { duration: 1, y: 50, ease: 'power2.out', opacity: 0 }, 'step1+=1.15')
        .addLabel('step2', '-=0.5')

        .from('.p-sec1__btn-link', { duration: 1, y: 100, ease: 'expo.inOut', opacity: 0 }, 'step2')
        .to('.p-sec1__title, .p-sec1__sub-title, .p-sec1__title-text', { duration: 1, y: -50, ease: 'expo.inOut' }, 'step2')
        .addLabel('step3', '-=0.4')

        .fromTo(mainCanvas.charLeft, { pixi: { alpha: 0, brightness: 3 }}, { pixi: {alpha: 1, brightness: 1}, ease: 'power2.inOut', duration: 2.5 }, 'step3')
        .fromTo(mainCanvas.charRight, { pixi: { alpha: 0, brightness: 3 }}, { pixi: {alpha: 1, brightness: 1}, ease: 'power2.inOut', duration: 2.5 }, 'step3')
        .addLabel('step4', '-=2.0')

        .from('.p-link__item', { y: 50, opacity: 0, duration: 1, stagger: 0.15, ease: 'power2.out'},'step4')
        .from('.p-util', { duration: 1, y: 100, ease: 'expo.inOut', opacity: 0 }, 'step4+=0.4')
        .from('.p-link__line', { duration: 1, scale: 0, opacity: 0, ease: 'power2.out' }, 'step4+=0.4')
        .add(() => {
            $('.p-link, .p-sec1__btn-link').removeClass('disable');

            let _over, _text, _target;
            $(document).on({
                'mouseenter': function(){
                    if( $(this).data().target == 'effect1'){
                        _target = mainCanvas.effect1;
                    }
                    else if( $(this).data().target == 'effect2'){
                        _target = mainCanvas.effect2;
                    }
                    else{
                        _target = mainCanvas.effect3;
                    }
                    _over = gsap.fromTo(_target, { pixi: { contrast: 1, alpha: 0 }}, { pixi: { contrast: 1.25, alpha: 1 }, duration: 0.7 })
                    _text = gsap.fromTo($(this).find('.p-link__txt'), { y: 10, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.07, duration: 0.7, ease: 'expo.inOut' });

                },
                'mouseleave': function(){
                    _over.reverse();
                    _text.reverse();
                }
            }, '.p-link__item')
        }, 'step4')

    animation.play();
});









var page = promokit.page({
    caution: false,
    cnb: true, //true, false
    topButton: true, //true, false
    footer: {
        theme: 'white', //'black', 'white'
        fixed: true
    },
    headerButton: {
        el: '.header-button',
        cookie: {
            type: 'year', //'year', 'week', 'day'
            key: 'INDEX_WEB_VISIT_210113_index',
            value: false
        },
        home: true,
        event: true,
        update: false,
        sns: true,
        theme: 'black' //'black', 'white'
    },
    remote: false
});


// WEBPACK FOOTER //
// ./src/js/index.js